
class SizeChart extends HTMLElement {
  constructor() {
    super();

    this.activeSize = false;
    this.activeType = "in";

    this.listeners();
    this.onSizeChange(this.activeSize);
  }
  

  listeners() {
    var self = this;

    // Store radops
    const radios = this.querySelectorAll('input[type="radio"]');
    const checks = this.querySelector('input[type="checkbox"]');

    document.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    this.querySelector('.size-chart__close').addEventListener('click', function(){
      self.close();
    });

    radios.forEach((radio) => {
      radio.addEventListener('change', (e) => {
        self.onSizeChange(e.target.value);
      });
    });
      
    checks.addEventListener('change', function(e){
      
      if(e.target.checked == true) {
        self.activeType = "cm";
      }else{
        self.activeType = "in";
      }

      // Run again to show/hide new sizes
      self.onSizeChange(self.activeSize);
    });
  }

  open() {
    this.classList.add('open');
  }

  close() {
    document.querySelector('size-chart-trigger').resetState();
    document.body.classList.remove('overflow-hidden');
    this.classList.remove('open');
  }

  onSizeChange(size) {

    // Set current active size
    this.activeSize = size;

    this.updateState();

    if( !size ) return;

    // Remove is--active
    const measurements = this.querySelectorAll('.size-chart-item__measurement');
    measurements.forEach((measurement) => {
      measurement.classList.remove('is--active');
    });

    // Add is--active
    const newMeasurements = this.querySelectorAll(`.size-chart-item__measurement[data-size="${size.toLowerCase()}"][data-type="${this.activeType}"]`);
    newMeasurements.forEach( (newMeasurement) => {
      newMeasurement.classList.add('is--active');
    });

    this.updateDefinition(size);
  }

  updateDefinition(size){

    const definitionItems = this.querySelectorAll('[data-definition]');

    definitionItems.forEach((definition) => {

      definition.classList.remove('is--active');

      if( definition.dataset.definition == size.toLowerCase() ){
        definition.classList.add('is--active');
      }
    });
  }

  updateState() {

    const measurements = this.querySelector('.size-chart__measurements');
    const footer = this.querySelector('.size-chart__footer');
    const notice = this.querySelector('.size-chart__notice');
    
    if( !this.activeSize ){
      measurements.classList.remove('is--visible');
      footer.classList.remove('is--visible');

      if( notice !== undefined && notice !== null ){
        notice.classList.add('is--visible');
      }

    }else{
      measurements.classList.add('is--visible');
      footer.classList.add('is--visible');

      if( notice !== undefined && notice !== null ){
        notice.classList.remove('is--visible');
      }
    }

  }
}

customElements.define('size-chart', SizeChart);

class SizeChartTrigger extends HTMLElement {
  constructor() {
    super();

    this.sizeChart = document.querySelector('size-chart');
    this.button = this.querySelector('button');
    this.addEventListener('click', this.onTriggerClick);
  }

  onTriggerClick(event) {
    const isOpen = this.hasAttribute('open');
    isOpen ? this.closeSizeChart() : this.openSizeChart();
  }

  resetState() {
    this.removeAttribute('open');
    this.button.classList.remove('is--active');
    document.body.classList.remove('overflow-hidden');
  }

  openSizeChart() {
    this.setAttribute('open', true);
    this.button.classList.add('is--active');
    document.body.classList.add('overflow-hidden');
    document.querySelector('size-chart').open();
  }

  closeSizeChart() {
    this.resetState();
    document.querySelector('size-chart').close();
  }
}

customElements.define('size-chart-trigger', SizeChartTrigger);

